/**
 * Attribution mark (AC 5.1/5.3). Persisted per-span attribution that travels on the CRDT
 * update — replacing today's transaction-scoped `APPLY_META`, so authorship survives reloads
 * and merges. INTERNAL PM file; only the plain {@link Attribution} shape is public.
 */

import type { MarkSpec } from 'prosemirror-model';
import type { Lane } from '../../types';

export const ATTRIBUTION_MARK = 'attribution';

export const attributionMark: MarkSpec = {
  attrs: {
    participantId: { default: '' },
    participantKind: { default: 'human' },
    displayName: { default: '' },
    model: { default: null },
    lane: { default: 'act' as Lane },
    ts: { default: null },
  },
  inclusive: false,
  parseDOM: [
    {
      tag: 'span[data-attribution-id]',
      getAttrs: (dom) => {
        const el = dom as HTMLElement;
        return {
          participantId: el.getAttribute('data-attribution-id') ?? '',
          participantKind: el.getAttribute('data-attribution-kind') ?? 'human',
          displayName: el.getAttribute('data-attribution-name') ?? '',
          model: el.getAttribute('data-attribution-model'),
          lane: (el.getAttribute('data-attribution-lane') as Lane) ?? 'act',
          ts: el.getAttribute('data-attribution-ts'),
        };
      },
    },
  ],
  toDOM: (mark) => [
    'span',
    {
      'data-attribution-id': mark.attrs.participantId,
      'data-attribution-kind': mark.attrs.participantKind,
      'data-attribution-name': mark.attrs.displayName,
      'data-attribution-model': mark.attrs.model ?? '',
      'data-attribution-lane': mark.attrs.lane,
      'data-attribution-ts': mark.attrs.ts ?? '',
      // AI edits are visually distinguishable — "no silent AI" (AC 5.4).
      class: mark.attrs.participantKind === 'ai' ? 'docit-attr-ai' : 'docit-attr-human',
    },
    0,
  ],
};
